import React, { useState, useEffect, useRef } from 'react';

// Page 3 Component - About Me
const Page3 = () => {
  return (
    <div className="flex w-full flex-col snap-start min-w-full h-full">
        <div className="relative z-10">
            <h2 className="about-blurb p3 max-w-4xl opacity-0 animate-fade-in"
            style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>Meet Rachel
            <div id="">
              I started building websites in 2014, combining an interest in design with a curiosity about code. What began with websites I'd be embarrassed to show today evolved into building full-scale applications from the ground up.
              <br></br><br></br>
              Over the past decade, I've built enterprise SaaS platforms, e-commerce solutions, web & mobile apps, customer management systems, and custom reporting tools.
              <br></br><br></br>
              I've taken ideas from initial concept through launch and beyond, working closely with founders, teams, and clients to bring their vision to life.
              <br></br><br></br>
              Based in LA, I'm available for both in-person meetings with local clients and remote work anywhere.
              <br></br><br></br>
              I've worked with clients across industries, from financial services to coffee shops, but I'm especially interested in hospitality tech and wellness projects.
              <br></br><br></br>
              Whether you have an idea you're ready to build, need a simple site for your side hustle, or just want to talk through possibilities, send me an <a href="mailto:rachel@manik-studio.com">email</a> or connect on <a href="https://www.linkedin.com/in/rachelbeneroff/">LinkedIn</a>.
              <br></br><br></br> I'd love to hear from you!
            </div>
            </h2>
        </div>
    </div>
  );
};

export default Page3;